import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";

import CNCBending from "../../assets/img/activity/cnc_bending.webp";
import CNCLaserCutting from "../../assets/img/activity/cnc_laser_cutting.webp";
import CNCShearing from "../../assets/img/activity/cnc_shearing.webp";
import MSFabrication from "../../assets/img/activity/msfabrication.webp";
import SSFabrication from "../../assets/img/activity/ss_fabrication.webp";
import angleBending from "../../assets/img/activity/ss-angle-bending.webp";
import flatBending from "../../assets/img/activity/flat-bending.webp";
import rolling from "../../assets/img/activity/rolling.webp";
import coneBending from "../../assets/img/activity/cone-bending.webp";

const OurActivity = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <section className="app-ourActivity" id="our-activity">
        <h2 className="app-ourActivity__headText">Our Activity</h2>
        <Grid
          container
          direction="row"
          alignItems="stretch"
          className="app-ourActivity__gridContainer"
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            // xl={3}
            className="app-ourActivity__grid"
          >
            <Card className="app-ourActivity__card">
              <CardContent>
                <h4 className="ourActivity-gridHeadText">
                  {/* <span className="ourActivity-gridHeadTextIcon"></span> */}
                  CNC Laser Cutting
                </h4>
                <img
                  className="ourActivity-img"
                  src={CNCLaserCutting}
                  alt="CNC Laser Cutting"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            // xl={3}
            className="app-ourActivity__grid"
          >
            <Card className="app-ourActivity__card">
              <CardContent>
                <h4 className="ourActivity-gridHeadText">
                  {/* <span className="ourActivity-gridHeadTextIcon"></span> */}
                  CNC Bending/Folding
                </h4>

                <img
                  className="ourActivity-img"
                  src={CNCBending}
                  alt="CNC Bending/Folding"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            // xl={3}
            className="app-ourActivity__grid"
          >
            <Card className="app-ourActivity__card">
              <CardContent>
                <h4 className="ourActivity-gridHeadText">
                  {/* <span className="ourActivity-gridHeadTextIcon"></span>NC */}
                  Shearing
                </h4>

                <img
                  className="ourActivity-img"
                  src={CNCShearing}
                  alt="Shearing"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            // xl={3}
            className="app-ourActivity__grid"
          >
            <Card className="app-ourActivity__card">
              <CardContent>
                <h4 className="ourActivity-gridHeadText">
                  {/* <span className="ourActivity-gridHeadTextIcon"></span>CNC Laser */}
                  MS Fabrication
                </h4>

                <img
                  className="ourActivity-img"
                  src={MSFabrication}
                  alt="MS Fabrication"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            // xl={3}
            className="app-ourActivity__grid"
          >
            <Card className="app-ourActivity__card">
              <CardContent>
                <h4 className="ourActivity-gridHeadText">
                  {/* <span className="ourActivity-gridHeadTextIcon"></span> */}
                  SS Fabrication
                </h4>

                <img
                  className="ourActivity-img"
                  src={SSFabrication}
                  alt="SS Fabrication"
                />
              </CardContent>
            </Card>
          </Grid>
          {/*  <Grid className="app-ourActivity__grid">
            <Card className="app-ourActivity__card app-ourActivity__cardFullWidth">
              <CardContent>
                <h4 className="ourActivity-gridHeadText">
                  Bending
                </h4>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                >
                  <Grid
                    item
                    xs={12}
                    md={3}
                    className="app-ourActivity__cardContent"
                  >
                    <img
                      className="ourActivity-img"
                      src={angleBending}
                      alt="Angle Bending"
                    />
                    <h4 className="ourActivity-gridHeadText">Angle Bending</h4>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={3}
                    className="app-ourActivity__cardContent"
                  >
                    <img
                      className="ourActivity-img"
                      src={flatBending}
                      alt="Flat Bending"
                    />
                    <h4 className="ourActivity-gridHeadText">Flat Bending</h4>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={3}
                    className="app-ourActivity__cardContent"
                  >
                    <img
                      className="ourActivity-img"
                      src={rolling}
                      alt="Rolling"
                    />
                    <h4 className="ourActivity-gridHeadText">Rolling</h4>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={3}
                    className="app-ourActivity__cardContent"
                  >
                    <img
                      className="ourActivity-img"
                      src={coneBending}
                      alt="Cone Bending"
                    />
                    <h4 className="ourActivity-gridHeadText">Cone Bending</h4>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
      </section>
      {/* <section className="kitchen-equipment-activity">
        <h1 className="kitchen-equipment-activity-headText">
          Kitchen Equipment's
        </h1>
        <p className="kitchen-equipment-activity-paraText">
          We also manufacture and supply wide range of products such as Steam
          Line Equipment, Commercial Trolley, Commercial Kitchen Equipment's and
          many more. All our products are widely appreciated by the customers
          for their corrosion and abrasion resistance, dimensional accuracy,
          robust construction, low maintenance and longer functional life.
        </p>
        <div className="view-catalogue-link">
          <Button
            variant="contained"
            size="large"
            onClick={(e) => {
              navigate("/kitchen-equipments", { replace: false });
            }}
          >
            <Icon fontSize="small" className="kitchen-icon">
              countertops
            </Icon>{" "}
            View Catalogue
          </Button>
        </div>
      </section> */}
    </Fragment>
  );
};

export default OurActivity;
